<template>
  <PortalPage
    :forecast-data="forecastData"
    :price-data="priceData"
    :general="general"
  />
</template>

<script setup lang="ts">
import PortalPage from '~/components/shared/price-assessments/PortalPage.vue'

import { LITHIUM_ION_BATTERIES, MARKET } from '~/constants/services/constants'
import { PRICE_ASSESSMENTS_LITHIUM_ION_BATTERIES } from '~/constants/services/price-assessments'
import { FORECASTS_LITHIUM_ION_BATTERIES } from '~/constants/services/forecasts'
import lithiumIonBatteriesPortalData from '~/constants/portal/lithium-ion-batteries'

/*-------------------------------------
  Constants
-------------------------------------*/
const general = {
  ...LITHIUM_ION_BATTERIES,
  ...lithiumIonBatteriesPortalData,
  title: LITHIUM_ION_BATTERIES.name,
  icon: LITHIUM_ION_BATTERIES.iconColor,
  categoryAnalysis: LITHIUM_ION_BATTERIES.slug,
  hideSustainabilityIndex: true,
}

const forecastData = FORECASTS_LITHIUM_ION_BATTERIES
const priceData = PRICE_ASSESSMENTS_LITHIUM_ION_BATTERIES

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ layout: 'services' })

/*-------------------------------------
  SEO
-------------------------------------*/
const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${LITHIUM_ION_BATTERIES.name} Portal`,
})
useHead(seo)
</script>
